const states = {
  Arizona: "AZ",
  Alabama: "AL",
  Alaska: "AK",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  "D.C.": "DC2",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

export const getStateAbbr = (state) => {
  return states[state];
};

const population = {
  AL: 4.93,
  AK: 3.03,
  AZ: 7.52,
  AR: 0.72,
  CA: 39.61,
  CO: 5.89,
  CT: 3.55,
  DC2: 18.3,
  DE: 0.99,
  FL: 21.94,
  GA: 10.83,
  HI: 1.41,
  ID: 1.86,
  IL: 12.57,
  IN: 6.81,
  IA: 3.17,
  KS: 2.92,
  KY: 4.48,
  LA: 4.63,
  ME: 1.35,
  MD: 6.07,
  MA: 6.91,
  MI: 9.99,
  MN: 5.71,
  MS: 2.97,
  MO: 6.17,
  MT: 1.09,
  NE: 1.95,
  NV: 3.19,
  NH: 1.37,
  NJ: 8.87,
  NM: 2.12,
  NY: 19.3,
  NC: 10.7,
  ND: 0.77,
  OH: 11.71,
  OK: 3.99,
  OR: 4.29,
  PA: 12.8,
  RI: 1.06,
  SC: 5.28,
  SD: 0.9,
  TN: 6.94,
  TX: 29.73,
  UT: 3.31,
  VT: 0.62,
  VA: 8.6,
  WA: 7.8,
  WV: 1.77,
  WI: 5.85,
  WY: 0.58,
};

export const getPopulation = (state) => {
  return population[state];
};
